import { render, staticRenderFns } from "./NestedList.vue?vue&type=template&id=1a45ccc8&scoped=true"
import script from "./NestedList.vue?vue&type=script&lang=js"
export * from "./NestedList.vue?vue&type=script&lang=js"
import style0 from "./NestedList.vue?vue&type=style&index=0&id=1a45ccc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a45ccc8",
  null
  
)

export default component.exports